import { gql } from '@apollo/client';

export const mutation = gql`
  mutation UpdateWebhookConfig($webhookConfigId: uuid!, $url: String, $eventTypes: [String!], $enabled: Boolean) {
    update_webhook_config(webhookConfigId: $webhookConfigId, url: $url, eventTypes: $eventTypes, enabled: $enabled) {
      id
      url
      event_types
      enabled_at
      updated_at
    }
  }
`;

export function buildVariables({ webhookConfigId, url, eventTypes, enabled }) {
  return { webhookConfigId, url, eventTypes, enabled };
}
